// extracted by mini-css-extract-plugin
export default {"beta-label":"Beta_beta-label__RtGRG"};